function getLength(level, childIndex, amountOfChildren) {

    const baseLength = 100;

    if (level > 2) {
        return baseLength * 0.5;
    }

    // For levels > 1 use different lengths (so that user can read titles)
    if (level > 1) {
        if (childIndex % 3 === 0) return baseLength * 1.5;
        else if (childIndex % 2 === 0) return baseLength;
        return baseLength * 2;
    }

    return baseLength;

}


export default function getEdgeConfig(from, to, level, childIndex, amountOfChildren) {

    const base = {
        from,
        to,
        smooth: false,
        color: {
            // inherit: 'from',
            color: '#ffffff',
            hover: '#ffffff',
            opacity: level === 1 ? 1 : level === 2 ? 0.5 : 0.3,
            highlight: '#ffffff',
        },
        // width: level === 1 ? 2 : 1,
        width: 4 / level,
        selectionWidth: width => width,
        // Level 2 has most nodes, needs longest edges
        length: getLength(level, childIndex, amountOfChildren),
    };
    return base;
}
